import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import ReactPaginateWrapper from '../../components/Pagination';

type selectedCategoryType = {
  major_category_id: number;
  sub_category_id: number;
};

// status: 0: not, 1: 검수중 2: 광고중 3: 반려됨
const testData = [
  {
    hotel_id: 0,
    hotel_name: '노크호텔',
    img_url: `${process.env.PUBLIC_URL}/img/hotel01.png`,
    distance: '1.5km',
    status: 0,
    device_num: 96,
  },
  {
    hotel_id: 1,
    hotel_name: '녹녹호텔',
    img_url: `${process.env.PUBLIC_URL}/img/hotel01.png`,
    distance: '1.2km',
    status: 1,
    device_num: 180,
  },
  {
    hotel_id: 2,
    hotel_name: '스루모텔',
    img_url: `${process.env.PUBLIC_URL}/img/hotel02.png`,
    distance: '3.2km',
    status: 2,
    device_num: 300,
  },
  {
    hotel_id: 3,
    hotel_name: '비하인드호텔',
    img_url: `${process.env.PUBLIC_URL}/img/hotel03.png`,
    distance: '4.5km',
    status: 3,
    device_num: 200,
  },
  {
    hotel_id: 4,
    hotel_name: '포스모텔',
    img_url: `${process.env.PUBLIC_URL}/img/food01.png`,
    distance: '7.5km',
    status: 3,
    device_num: 540,
  },
  {
    hotel_id: 5,
    hotel_name: '키오스크여관',
    img_url: `${process.env.PUBLIC_URL}/img/food01.png`,
    distance: '14.0km',
    status: 1,
    device_num: 200,
  },
  {
    hotel_id: 6,
    hotel_name: 'The kds',
    img_url: `${process.env.PUBLIC_URL}/img/hotel04.png`,
    distance: '0.2km',
    status: 2,
    device_num: 100,
  },
  {
    hotel_id: 7,
    hotel_name: 'kpi호텔',
    img_url: `${process.env.PUBLIC_URL}/img/food01.png`,
    distance: '1.3km',
    status: 0,
    device_num: 200,
  },
  {
    hotel_id: 8,
    hotel_name: '관리자모텔',
    img_url: `${process.env.PUBLIC_URL}/img/hotel05.png`,
    distance: '0.1km',
    status: 0,
    device_num: 200,
  },
  {
    hotel_id: 9,
    hotel_name: '오운호텔',
    img_url: `${process.env.PUBLIC_URL}/img/food01.png`,
    distance: '1.1km',
    status: 3,
    device_num: 124,
  },
  {
    hotel_id: 10,
    hotel_name: '이름못정하겠다이름못정하겠다',
    img_url: `${process.env.PUBLIC_URL}/img/hotel06.png`,
    distance: '0.7km',
    status: 0,
    device_num: 76,
  },
];

const StoreInspect = () => {
  const [inspectType, setInspectType] = useState<number>(0);
  // 현재 페이지
  const [currentPage, setCurrentPage] = useState<number>(1);
  // 당일 매출건수의 페이지 개수
  const [pageCount, setPageCount] = useState<number>(5);

  const RenderListItem = ({ item, index }: any) => {
    return (
      <div className="listItem">
        <div className="row">
          <div className="indexBox">{index + 1}</div>
          <img src={item.img_url} alt="매장이미지" />
          <div className="row name">
            <h3>{item.hotel_name}</h3>
            <h3>{item.distance}</h3>
          </div>
        </div>

        <div className="row gap">
          <button className="statusButton">
            <h5>매장정보</h5>
          </button>
          <button className="statusButton advertise">
            <h5>광고중</h5>
          </button>
        </div>
      </div>
    );
  };

  return (
    <>
      <Style>
        <div className="contentContainer">
          <div className="selectBoxWrap">
            <div
              className={`selectBox left ${inspectType === 0 && 'active'}`}
              onClick={() => setInspectType(0)}>
              검수 필요한 매장
            </div>
            <div
              className={`selectBox right ${inspectType === 1 && 'active'}`}
              onClick={() => setInspectType(1)}>
              입점매장
            </div>
          </div>
          <div className="listWrap">
            {testData.map((item: any, index: number) => {
              return <RenderListItem key={index} item={item} index={index} />;
            })}
          </div>
          <ReactPaginateWrapper
            pageCount={pageCount}
            forcePage={currentPage - 1}
            handlePageClick={() => {}}
          />
        </div>
      </Style>
    </>
  );
};

export default StoreInspect;

const Style = styled.div`
  .contentContainer:nth-child(1) {
    border-radius: 10px;
  }

  .selectBoxWrap {
    display: flex;
    align-items: center;
    padding-bottom: 20px;

    .selectBox {
      flex: 1;
      border: 1px solid #cecece;
      background: #f7f7f7;
      font-size: 14px;
      line-height: 20px;
      color: #555555;
      padding: 8px 0;
      text-align: center;
      cursor: pointer;
    }
    .selectBox.left {
      border-radius: 5px 0px 0px 5px;
      border-right: none;
    }
    .selectBox.right {
      border-radius: 0px 5px 5px 0px;
      border-left: none;
    }
    .selectBox.active {
      border: 1px solid #4dd2ae;
      background: #ecf5f3;
      color: #40977f;
    }
  }

  .listWrap {
    display: flex;
    flex-direction: column;
    gap: 10px;
    .listItem {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 10px 24px 10px 16px;
      border: 1px solid #e5e5e5;
      border-radius: 5px;

      .row {
        gap: 12px;
      }
      .indexBox {
        width: 24px;
        height: 24px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        font-weight: 500;
        color: #979797;
        border-radius: 3px;
        border: 1px solid #cecece;
      }
      img {
        width: 80px;
        height: 80px;
        border-radius: 5px;
        object-fit: contain;
      }
      .row.name {
        justify-content: space-between;
        width: 260px;
        padding-left: 12px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      h3 {
        width: 100%;
        color: #555555;
        font-weight: 500;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }

      .row.gap {
        gap: 20px;
      }
      .statusButton {
        min-width: 64px;
        padding: 3px 10px;
        border-radius: 5px;
        border: 1px solid #e5e5e5;
        background: #ffffff;
        text-align: center;
        h5 {
          color: #a7a7a7;
        }
      }
      .statusButton.advertise {
        border: 1px solid #ff6060;
        background: #ff6060;
        h5 {
          color: #ffffff;
        }
      }
    }
  }

  @media (max-width: 600px) {
    .listWrap {
      .listItem {
        padding: 6px 18px 6px 12px;
        .row {
          gap: 10px;
        }

        img {
          width: 70px;
          height: 70px;
        }
        .row.name {
          width: 130px;
          padding-left: 10px;
          align-items: flex-start;
          flex-direction: column;
          gap: 8px;
        }
        h3 {
          min-width: 100px;
          font-size: 16px;
        }

        .row.gap {
          flex-direction: column;
          gap: 8px;
        }
        .statusButton {
          min-width: 64px;
          padding: 3px 8px;
        }
      }
    }
  }
`;
